import { Inject, Injectable } from '@angular/core';

import { RaceEntity, RacingProviders } from '@cds/betting-offer/domain-specific/horse-racing';
import { HorsePerformanceData } from '@cds/betting-offer/domain-specific/horse-racing/timeform';
import { DetailedCreateFactory, DetailedGroupingFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { OfferGroupingService } from '@frontend/sports/betting-offer/feature/offer-grouping';
import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { WinGameFixture, toHorseRacingTimeFormFixture } from '@frontend/sports/racing/feature/models';
import { Observable, catchError, map, of } from 'rxjs';

import { AbstractRacingService } from './racing-api.service';

@Injectable({
    providedIn: 'root',
})
export class HorseRacingApiService extends AbstractRacingService {
    ToFixture(raceEntity: RaceEntity): WinGameFixture {
        return toHorseRacingTimeFormFixture(raceEntity);
    }

    provider(): RacingProviders {
        return RacingProviders.Timeform;
    }

    constructor(
        @Inject(CDS_API_FACTORY) cdsApiServiceFactory: BaseCdsApiFactory,
        protected override racingConfig: RacingConfig,
        protected override offerGroupingService: OfferGroupingService,
        protected override createFactory: DetailedCreateFactory,
        protected override groupingFactory: DetailedGroupingFactory,
    ) {
        super(cdsApiServiceFactory, racingConfig, '/horse-racing', offerGroupingService, createFactory, groupingFactory);
    }

    getHorsePerformance(fixtureId: string, participantId: number): Observable<HorsePerformanceData[]> {
        const empty: HorsePerformanceData[] = [];

        return this.cdsApi
            .get<{ [participantId: number]: HorsePerformanceData[] }>(`/horse-performance/${fixtureId}`, {
                participantId: [participantId],
            })
            .pipe(
                map((value) => {
                    return value ? value[participantId] || empty : empty;
                }),
                catchError(() => {
                    return of(empty);
                }),
            );
    }
}
